interface FaqSectionProps {
  faqs: Array<{ question: string; answer: string }>;
  heading?: string;
  headingLevel?: 'h2' | 'h3';
}

export function FaqSection({ faqs, heading, headingLevel = 'h2' }: FaqSectionProps) {
  if (faqs.length === 0) return null;
  const Heading = headingLevel;
  return (
    <>
      {heading && (
        <Heading className="font-heading text-xl font-bold text-text-primary md:text-2xl">
          {heading}
        </Heading>
      )}
      <dl className={heading ? 'mt-6 space-y-6' : 'space-y-6'}>
        {faqs.map((faq, i) => (
          <div key={i}>
            <dt className="text-sm font-semibold text-text-primary md:text-base">
              {faq.question}
            </dt>
            <dd className="mt-1 text-sm leading-relaxed text-text-secondary md:text-base">
              {faq.answer}
            </dd>
          </div>
        ))}
      </dl>
    </>
  );
}
